<template>
  <div class="SelectDonationContainer">
    <div class="SelectDonation">
        <div class="d-flex a-center">
          <Checkbox id="CheckboxAgree" :value="checkedRoundUp" @input="onCheckRoundUp" />
            <img src="../../../assets/img/donate.svg" />
            <div class="Label">{{roundUpAmount}} TL bağışlamak için</div>
        </div>
        <SelectBox
                id="SelectFoundation"
                :disabled="!checkedRoundUp"
                placeholder="Sivil toplum kuruluşu seçiniz"
                :value="foundation"
                @input="onChange($event)"
                :options="stkOptions"
                :showOptions="showOpts"
        />
    </div>
    <Checkbox v-if="foundation"
        id="CheckboxAgree" :value="checked" @input="onCheck"
    >
      <span>{{roundUpConfirmationMessage}}</span>
    </Checkbox>
  </div>

</template>
<script>
  import {mapGetters} from "vuex"
  export default {
    name: "SelectDonation",
    components: {
      Checkbox: () => import("../Checkbox"),
      SelectBox: () => import("../SelectBox")
    },
    data: () => ({
      checkedRoundUp: false,
      checked: false,
      foundation: null,
      stkOptions:[],
      showOpts:false,
      options: [
        { label: "KAÇUV", value: "kacuv" },
        { label: "AÇEV", value: "acev" }
      ]
    }),
    mounted(){
      //console.log("Mounted-SelectDonation-value:",this.value);
      //console.log("getLastDonatedStkId:",this.lastDonatedStkId)
      this.foundation = this.lastDonatedStkId;
      this.prepareStkOptions();

    },
    computed:{
      ...mapGetters({
        stkMerchants:'getStkMerchants',
        roundUpAmount:'getRoundUpAmount',
        getStkRoundUpInfo:'getStkRoundUpInfo',
        lastDonatedStkId:'getLastDonatedStkId',
        roundUpConfirmationMessage:'getRoundUpConfirmationMessage'
      })
    },

    methods: {
      onChange(value) {
        //console.log("SelectDonation-onChange-value:",value);
        this.foundation = value;
        //if (!this.checked) {
        this.$emit("input", value);
        this.$emit("isChecked", this.checked);
        //}
      },
      onCheckRoundUp(value){
        this.checkedRoundUp = value;
        if(this.checkedRoundUp === false){
          this.checked = false;
          this.foundation = false;
          this.$emit("isChecked", this.checked);
        }
        this.$emit("isCheckedRoundUp", this.checkedRoundUp);
      },
      onCheck(value) {
          //console.log("onCheck:",value)
          //if (!value) {
          this.checked = value;
          this.showOpts=this.checked;
          if(value===false)
            this.foundation = null;
          this.$emit("input", this.foundation);
          this.$emit("isChecked", this.checked);
          //, "isChecked": this.checked

        //}
      },
      async prepareStkOptions(){
        if(this.stkMerchants===undefined){
          //console.log("prepareStkOptions-stkM undefined")
          await setTimeout(()=>{console.log("timeout Finished")
            return Promise.resolve();
          },1000);
        }
        this.stkMerchants.forEach((item)=>{
          let stkMerchant = {label: item.name, value: item.indicator}
          this.stkOptions.push(stkMerchant);
        });
        //console.log("prepareStkOptionsResult:",this.stkOptions);
        return this.stkOptions;
      }

    }
  };
</script>